import { ContentTypeEnum } from '../enums/content-type.enum';

export abstract class BaseContentModel {
  type: ContentTypeEnum;

  protected constructor(type: ContentTypeEnum) {
    this.type = type;
  }
}
